import pizzaImg01 from "./assets/pizza1.png";
import fastFood03 from "./assets/chicken3.png";
import fastFood04 from "./assets/chicken4.png";
import dessert02 from "./assets/dessert02.png";

import dessert03 from "./assets/dessert2.png";
import dessert04 from "./assets/dessert3.png";
import coffeeImg02 from "./assets/coffe2.png";

export const foodMenu = [
  {
    id: "01",
    title: "Vegetable Salad",
    price: 25,
    imgUrl: fastFood03,
    foodDesc: "Best pizza in the world",

    type: "BreakFast",
    urlParamName: "breakfast",
  },
  {
    id: "02",
    title: "Chicken",
    price: 250,
    imgUrl: fastFood04,
    foodDesc: "Best pizza in the world",

    type: "Dinner",
    urlParamName: "dinner",
  },

  {
    id: "03",
    title: "Whipped Cream",
    price: 45,
    imgUrl: dessert02,
    foodDesc: "Best pizza in the world",

    type: "BreakFast",
    urlParamName: "breakfast",
  },

  {
    id: "04",
    title: "Pizza",
    price: 75,
    imgUrl: dessert03,
    foodDesc: "Best pizza in the world",

    type: "Other",
    urlParamName: "other",
  },
  {
    id: "05",
    title: "Pizza",
    price: 75,
    imgUrl: dessert04,
    foodDesc: "Best pizza in the world",

    type: "Lunch",
    urlParamName: "lunch",
  },
  {
    id: "06",
    title: "Pizza",
    price: 75,
    imgUrl: coffeeImg02,
    foodDesc: "Best pizza in the world",

    type: "Dinner",
    urlParamName: "dinner",
  },
];
